var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"uk-grid":"","uk-height-match":">div>.uk-card"}},_vm._l((_vm.addresses),function(item){return _c('address-item',{key:item.id,attrs:{"is-default":item.id == _vm.defaultKey,"address":item}})}),1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71b19d99","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/addressing/AddressesList.vue
// module id = RPAo
// module chunks = 0